import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Lines = ({ lines, className = "", delay = 0, once = true, as = "h2", testId }) => {
  const Tag = motion[as] ?? motion.h2;
  return (
    <Tag
      className={className}
      data-testid={testId}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once, amount: 0.3 }}
      transition={{ duration: 0.7, ease: EASE, delay }}
    >
      {lines.map((line, i) => (
        <span className="block" key={i}>
          {line}
        </span>
      ))}
    </Tag>
  );
};

export const Fade = ({ children, className = "", delay = 0, y = 8, once = true, testId }) => (
  <motion.div
    className={className}
    data-testid={testId}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.3 }}
    transition={{ duration: 0.7, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
